import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@material-ui/core';
import { FileDrop } from 'react-file-drop';
import {
  Icon,
  Typography,
  knockTheme,
} from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../../knock-design-system';

export const HIDDEN_INPUT_LABEL = 'file-input';

const useCss = makeCss({
  uploadCard: {
    marginTop: '16px',
    borderStyle: 'dashed',
    cursor: 'pointer',
    '& .drop-target-drag-over-active': {
      backgroundColor: knockTheme.palette.denim[50],
      border: `1px dashed ${knockTheme.palette.denim[500]}`,
      borderRadius: '8px',
    },
  },
  uploadCardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: '8px',
  },
});

export const PropertiesImportDropzone = ({
  clearErrorMessage,
  fileInputRef,
  handleFile,
  handleDropTargetClick,
  invalidFileMessage,
}) => {
  const css = useCss();
  const dropFrameRef = useRef();

  return (
    <Card css={css.uploadCard} variant="outlined">
      <FileDrop
        draggingOverTargetClassName="drop-target-drag-over-active"
        frame={dropFrameRef.current}
        onFrameDragEnter={clearErrorMessage}
        onDrop={handleFile}
        onTargetClick={handleDropTargetClick}
      >
        <CardContent css={css.uploadCardContent} ref={dropFrameRef}>
          <Icon name="upload" />

          <Typography>
            <Typography component="span" color="primary.600">
              Click to import CSV
            </Typography>{' '}
            or drag and drop
          </Typography>
          {invalidFileMessage && (
            <Typography color="error.500" variant="body2">
              {invalidFileMessage}
            </Typography>
          )}
        </CardContent>
      </FileDrop>

      <input
        accept=".csv"
        aria-label={HIDDEN_INPUT_LABEL}
        aria-hidden
        hidden
        onChange={(e) => handleFile(e.target.files)}
        ref={fileInputRef}
        type="file"
      />
    </Card>
  );
};

PropertiesImportDropzone.propTypes = {
  clearErrorMessage: PropTypes.func,
  fileInputRef: PropTypes.object,
  handleFile: PropTypes.func,
  handleDropTargetClick: PropTypes.func,
  invalidFileMessage: PropTypes.string,
};
